import React from "react";
import { DisplayBox } from "../../components";
import { ApiHelper, DateHelper, SupportTicketInterface } from "../../helpers";
import { TicketDetails } from "./TicketDetails";

interface Props { }

export const AdminTickets: React.FC<Props> = props => {

  const [tickets, setTickets] = React.useState<SupportTicketInterface[]>(null);
  const [selectedTicket, setSelectedTicket] = React.useState<SupportTicketInterface>(null);

  const getRows = () => {
    const result: React.ReactElement[] = [];
    tickets?.forEach(t => {
      const ticket = t;
      result.push(<tr>
        <td><a href="about:blank" onClick={(e) => { e.preventDefault(); setSelectedTicket(ticket) }}>{t.id}</a></td>
        <td>
          {DateHelper.getDisplayDuration(DateHelper.convertToDate(t.lastUpdated))}
        </td>
      </tr>)
    })
    if (result.length > 0) return result;
    else return <p>There are no open tickets.</p>
  }

  const init = () => {
    ApiHelper.get<SupportTicketInterface[]>("/supportTickets/admin").then((data) => setTickets(data || []));
    setSelectedTicket(null);
  }

  React.useEffect(init, [])



  const getDetails = () => {
    if (selectedTicket) return <TicketDetails ticket={selectedTicket} onDone={init} />
  }

  if (selectedTicket) return getDetails();
  else return (
    <DisplayBox headerIcon="fas fa-comments" headerText="Support Tickets" >
      <table className="table table-sm">
        <tr><th>Ticket #</th><th>Last Updated</th></tr>
        {getRows()}
      </table>
    </DisplayBox>
  );

};